/* ==========================================================================
   Oro di Sicilia — Personalizzatore
   assets/odsz-personalizzatore.js

   Modulo di personalizzazione con anteprima live, scelta font/grafica,
   caricamento immagine del cliente e generazione automatica del file di
   stampa/incisione allegato all'ordine come line item property.

   Nota tecnica: Shopify NON accetta file upload tramite Cart AJAX API.
   Per questo il modulo usa un form classico POST /cart/add con
   enctype="multipart/form-data".
   ========================================================================== */

(function () {
  'use strict';

  var MM_PER_INCH = 25.4;

  /* ---------------------------------------------------------------- utils */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, value)
                   .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value);
    }
    return '€' + value;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function readFileAsImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { resolve({ img: img, url: url }); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('immagine non leggibile')); };
      img.src = url;
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve) {
      canvas.toBlob(function (b) { resolve(b); }, type, quality);
    });
  }

  /** Allega un Blob a un <input type="file"> reale, così Shopify lo salva
      come file dell'ordine. */
  function attachFile(input, blob, filename) {
    if (!input || !blob) return false;
    try {
      var file = new File([blob], filename, { type: blob.type, lastModified: Date.now() });
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
      return input.files.length === 1;
    } catch (e) {
      return false;
    }
  }

  /* --------------------------------------------------------- disegno base */

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function wrapLines(ctx, text, maxWidth) {
    var out = [];
    String(text).split('\n').forEach(function (para) {
      var words = para.split(/\s+/).filter(Boolean);
      if (!words.length) { out.push(''); return; }
      var line = words.shift();
      words.forEach(function (w) {
        var test = line + ' ' + w;
        if (ctx.measureText(test).width <= maxWidth) line = test;
        else { out.push(line); line = w; }
      });
      out.push(line);
    });
    return out;
  }

  /* ==========================================================================
     Personalizzatore
     ========================================================================== */

  function Personalizzatore(root) {
    this.root = root;
    this.cfg = JSON.parse($('[data-odsz-config]', root).textContent);
    this.form = $('[data-odsz-form]', root);
    this.canvas = $('[data-odsz-canvas]', root);
    this.ctx = this.canvas.getContext('2d');

    this.view = 'artwork';
    this.logoImg = null;
    this.logoUrl = null;

    this.state = {
      template: this.cfg.templates[0].id,
      bg: this.cfg.templates[0].bg,
      ink: this.cfg.templates[0].ink,
      frame: this.cfg.templates[0].frame,
      font: this.cfg.templates[0].font,
      title: '',
      subtitle: '',
      date: '',
      titleY: 0.34,
      subtitleY: 0.54,
      dateY: 0.74,
      titleSize: 11,
      subtitleSize: 5.4,
      logo: { x: 0.5, y: 0.17, scale: 0.34 },
      packIndex: 0,
      wines: []
    };

    this.setupCanvas();
    this.readInitialValues();
    this.bind();
    this.syncPack();
    this.loadFonts().then(this.render.bind(this));
  }

  /* ------------------------------------------------------------- canvas */

  Personalizzatore.prototype.printPx = function () {
    var c = this.cfg;
    return {
      w: Math.round(c.printWidthMm / MM_PER_INCH * c.dpi),
      h: Math.round(c.printHeightMm / MM_PER_INCH * c.dpi)
    };
  };

  Personalizzatore.prototype.setupCanvas = function () {
    // Il canvas a schermo lavora a risoluzione ridotta (veloce da ridisegnare);
    // l'export rigenera tutto alla risoluzione di stampa.
    var p = this.printPx();
    var scale = Math.min(1, 900 / Math.max(p.w, p.h));
    this.canvas.width = Math.round(p.w * scale);
    this.canvas.height = Math.round(p.h * scale);
    var maxCss = this.cfg.mode === 'cassa' ? 560 : 400;
    var cssW = Math.min(maxCss, this.canvas.width);
    this.canvas.style.width = cssW + 'px';
    this.canvas.style.height = 'auto';
  };

  /** Recupera i valori già presenti nei campi (testi d'esempio precompilati),
      così l'anteprima non parte mai vuota. */
  Personalizzatore.prototype.readInitialValues = function () {
    var r = this.root, s = this.state;
    var title = $('[data-odsz-title]', r);
    var sub = $('[data-odsz-subtitle]', r);
    var date = $('[data-odsz-date]', r);
    if (title && title.value) s.title = title.value;
    if (sub && sub.value) s.subtitle = sub.value;
    if (date && date.value) s.date = date.value;

    $$('[data-odsz-range]', r).forEach(function (input) {
      var key = input.getAttribute('data-odsz-range');
      var v = parseFloat(input.value);
      if (isNaN(v)) return;
      if (key === 'logoScale') s.logo.scale = v;
      else if (key === 'logoY') s.logo.y = v;
      else s[key] = v;
    });

    $$('[data-odsz-count]', r).forEach(function (c) {
      var field = c.parentNode.querySelector('input, textarea');
      if (field && field.maxLength > 0) c.textContent = field.value.length + ' / ' + field.maxLength;
    });

    var frame = $('[data-odsz-frame]', r);
    if (frame && frame.value) s.frame = frame.value;
  };

  Personalizzatore.prototype.loadFonts = function () {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var jobs = this.cfg.fonts.map(function (f) {
      return document.fonts.load('700 64px "' + f.family + '"');
    });
    return Promise.all(jobs).catch(function () {});
  };

  /* ------------------------------------------------------------- disegno */

  /**
   * Disegna la grafica sul contesto dato.
   * @param {Object} o { w, h, mono }  mono = versione per incisione laser (B/N)
   */
  Personalizzatore.prototype.drawArtwork = function (ctx, o) {
    var s = this.state, cfg = this.cfg;
    var W = o.w, H = o.h, mono = !!o.mono;
    var ink = mono ? '#000000' : s.ink;

    ctx.save();
    ctx.clearRect(0, 0, W, H);

    // sfondo
    if (mono) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, W, H);
    } else {
      var tpl = this.template();
      if (tpl.gradient) {
        var g = ctx.createLinearGradient(0, 0, 0, H);
        g.addColorStop(0, tpl.gradient[0]);
        g.addColorStop(1, tpl.gradient[1]);
        ctx.fillStyle = g;
      } else {
        ctx.fillStyle = s.bg;
      }
      ctx.fillRect(0, 0, W, H);
      if (cfg.mode === 'cassa') this.drawWood(ctx, W, H);
    }

    // cornice
    this.drawFrame(ctx, W, H, ink);

    // logo / immagine del cliente
    if (this.logoImg) this.drawLogo(ctx, W, H, mono);

    // testi
    ctx.fillStyle = ink;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    var pad = W * 0.14;
    var maxW = W - pad * 2;

    if (s.title) {
      this.drawTextBlock(ctx, s.title, {
        y: s.titleY * H, maxW: maxW, cx: W / 2,
        size: W * (s.titleSize / 100),
        font: s.font, weight: 700, tracking: W * 0.004, upper: this.template().upper
      });
    }

    if (s.subtitle) {
      this.drawTextBlock(ctx, s.subtitle, {
        y: s.subtitleY * H, maxW: maxW, cx: W / 2,
        size: W * (s.subtitleSize / 100),
        font: s.font, weight: 400, tracking: W * 0.002, upper: false
      });
    }

    if (s.date) {
      this.drawTextBlock(ctx, s.date, {
        y: s.dateY * H, maxW: maxW, cx: W / 2,
        size: W * 0.042,
        font: cfg.fonts[0].family, weight: 400, tracking: W * 0.012, upper: true
      });
    }

    ctx.restore();
  };

  Personalizzatore.prototype.drawTextBlock = function (ctx, text, o) {
    var value = o.upper ? String(text).toUpperCase() : String(text);
    var size = o.size;
    ctx.font = o.weight + ' ' + size + 'px "' + o.font + '", serif';
    if ('letterSpacing' in ctx) ctx.letterSpacing = o.tracking + 'px';

    var lines = wrapLines(ctx, value, o.maxW);

    // riduce il corpo se il testo è troppo lungo
    var guard = 0;
    while (lines.length > 3 && size > o.size * 0.55 && guard++ < 20) {
      size *= 0.92;
      ctx.font = o.weight + ' ' + size + 'px "' + o.font + '", serif';
      lines = wrapLines(ctx, value, o.maxW);
    }

    var lh = size * 1.22;
    var start = o.y - ((lines.length - 1) * lh) / 2;
    lines.forEach(function (line, i) {
      ctx.fillText(line, o.cx, start + i * lh);
    });

    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
  };

  Personalizzatore.prototype.drawFrame = function (ctx, W, H, ink) {
    var f = this.state.frame;
    if (f === 'nessuna') return;
    ctx.save();
    ctx.strokeStyle = ink;
    var m = W * 0.055;

    if (f === 'filetto') {
      ctx.lineWidth = Math.max(1, W * 0.004);
      ctx.strokeRect(m, m, W - m * 2, H - m * 2);
    } else if (f === 'doppia') {
      ctx.lineWidth = Math.max(1, W * 0.006);
      ctx.strokeRect(m, m, W - m * 2, H - m * 2);
      ctx.lineWidth = Math.max(1, W * 0.002);
      var m2 = m + W * 0.022;
      ctx.strokeRect(m2, m2, W - m2 * 2, H - m2 * 2);
    } else if (f === 'angoli') {
      ctx.lineWidth = Math.max(1, W * 0.006);
      var L = W * 0.13;
      [[m, m, 1, 1], [W - m, m, -1, 1], [m, H - m, 1, -1], [W - m, H - m, -1, -1]]
        .forEach(function (c) {
          ctx.beginPath();
          ctx.moveTo(c[0] + c[2] * L, c[1]);
          ctx.lineTo(c[0], c[1]);
          ctx.lineTo(c[0], c[1] + c[3] * L);
          ctx.stroke();
        });
    } else if (f === 'arco') {
      ctx.lineWidth = Math.max(1, W * 0.005);
      roundRect(ctx, m, m, W - m * 2, H - m * 2, W * 0.18);
      ctx.stroke();
    }
    ctx.restore();
  };

  Personalizzatore.prototype.drawWood = function (ctx, W, H) {
    ctx.save();
    ctx.globalAlpha = 0.12;
    ctx.strokeStyle = '#6b4a24';
    for (var i = 0; i < 34; i++) {
      var y = (i / 34) * H + Math.sin(i) * 3;
      ctx.lineWidth = 1 + (i % 3);
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.bezierCurveTo(W * 0.3, y + 6, W * 0.7, y - 6, W, y + 2);
      ctx.stroke();
    }
    ctx.restore();
  };

  Personalizzatore.prototype.logoRect = function (W, H) {
    var s = this.state.logo;
    var natural = this.logoImg.naturalWidth / this.logoImg.naturalHeight;
    var w = W * s.scale;
    var h = w / natural;
    return { x: s.x * W - w / 2, y: s.y * H - h / 2, w: w, h: h };
  };

  Personalizzatore.prototype.drawLogo = function (ctx, W, H, mono) {
    var r = this.logoRect(W, H);
    if (!mono) { ctx.drawImage(this.logoImg, r.x, r.y, r.w, r.h); return; }

    // Versione incisione: soglia a bianco/nero su canvas temporaneo
    var tmp = document.createElement('canvas');
    tmp.width = Math.max(1, Math.round(r.w));
    tmp.height = Math.max(1, Math.round(r.h));
    var tc = tmp.getContext('2d');
    tc.drawImage(this.logoImg, 0, 0, tmp.width, tmp.height);
    var d = tc.getImageData(0, 0, tmp.width, tmp.height);
    var px = d.data;
    for (var i = 0; i < px.length; i += 4) {
      var lum = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2];
      var on = px[i + 3] > 40 && lum < 165;
      px[i] = px[i + 1] = px[i + 2] = 0;
      px[i + 3] = on ? 255 : 0;
    }
    tc.putImageData(d, 0, 0);
    ctx.drawImage(tmp, r.x, r.y, r.w, r.h);
  };

  /** Mockup: bottiglia (etichetta) o cassa in legno vista dall'alto. */
  Personalizzatore.prototype.drawMockup = function (ctx, W, H) {
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#efe9dc';
    ctx.fillRect(0, 0, W, H);

    var art = document.createElement('canvas');
    var p = this.printPx();
    art.width = Math.round(p.w * 0.5);
    art.height = Math.round(p.h * 0.5);
    this.drawArtwork(art.getContext('2d'), { w: art.width, h: art.height, mono: false });

    if (this.cfg.mode === 'cassa') {
      var bw = W * 0.86, bh = H * 0.7;
      var bx = (W - bw) / 2, by = (H - bh) / 2;
      ctx.save();
      var g = ctx.createLinearGradient(bx, by, bx, by + bh);
      g.addColorStop(0, '#c89a5e'); g.addColorStop(1, '#a9793f');
      ctx.fillStyle = g;
      roundRect(ctx, bx, by, bw, bh, 10); ctx.fill();
      ctx.strokeStyle = 'rgba(0,0,0,.25)'; ctx.lineWidth = 2; ctx.stroke();
      var iw = bw * 0.8, ih = iw * (art.height / art.width);
      if (ih > bh * 0.8) { ih = bh * 0.8; iw = ih * (art.width / art.height); }
      ctx.globalAlpha = 0.92;
      ctx.drawImage(art, bx + (bw - iw) / 2, by + (bh - ih) / 2, iw, ih);
      ctx.restore();
      return;
    }

    // bottiglia
    var cx = W / 2;
    var bodyW = W * 0.42, bodyTop = H * 0.3, bodyH = H * 0.68;
    ctx.save();
    var gb = ctx.createLinearGradient(cx - bodyW / 2, 0, cx + bodyW / 2, 0);
    gb.addColorStop(0, '#1f3a22'); gb.addColorStop(0.35, '#3f6b44');
    gb.addColorStop(0.6, '#2c4f31'); gb.addColorStop(1, '#16281a');
    ctx.fillStyle = gb;
    ctx.beginPath();
    ctx.moveTo(cx - bodyW / 2, bodyTop + bodyH);
    ctx.lineTo(cx - bodyW / 2, bodyTop + H * 0.08);
    ctx.quadraticCurveTo(cx - bodyW / 2, bodyTop - H * 0.04, cx - W * 0.075, H * 0.16);
    ctx.lineTo(cx - W * 0.075, H * 0.04);
    ctx.lineTo(cx + W * 0.075, H * 0.04);
    ctx.lineTo(cx + W * 0.075, H * 0.16);
    ctx.quadraticCurveTo(cx + bodyW / 2, bodyTop - H * 0.04, cx + bodyW / 2, bodyTop + H * 0.08);
    ctx.lineTo(cx + bodyW / 2, bodyTop + bodyH);
    ctx.closePath();
    ctx.fill();

    ctx.fillStyle = '#7c1c2c';
    ctx.fillRect(cx - W * 0.078, H * 0.03, W * 0.156, H * 0.1);

    var lw = bodyW * 0.78;
    var lh = lw * (art.height / art.width);
    ctx.drawImage(art, cx - lw / 2, bodyTop + bodyH * 0.28, lw, lh);

    ctx.globalAlpha = 0.18;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(cx - bodyW * 0.34, H * 0.06, bodyW * 0.1, bodyH * 0.9);
    ctx.restore();
  };

  Personalizzatore.prototype.render = function () {
    var W = this.canvas.width, H = this.canvas.height;
    if (this.view === 'mockup') this.drawMockup(this.ctx, W, H);
    else this.drawArtwork(this.ctx, { w: W, h: H, mono: false });
    this.canvas.classList.toggle('odsz__canvas--draggable', !!this.logoImg && this.view === 'artwork');
    this.updateSummaries();
  };

  /* -------------------------------------------------------------- export */

  Personalizzatore.prototype.exportArtwork = function (mono) {
    var p = this.printPx();
    var c = document.createElement('canvas');
    c.width = p.w; c.height = p.h;
    this.drawArtwork(c.getContext('2d'), { w: p.w, h: p.h, mono: !!mono });
    return canvasToBlob(c, 'image/png');
  };

  Personalizzatore.prototype.exportPreview = function () {
    var c = document.createElement('canvas');
    c.width = 900; c.height = 1200;
    this.drawMockup(c.getContext('2d'), c.width, c.height);
    return canvasToBlob(c, 'image/jpeg', 0.86);
  };

  /* ---------------------------------------------------------------- dati */

  Personalizzatore.prototype.template = function () {
    var id = this.state.template, list = this.cfg.templates;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  };

  Personalizzatore.prototype.pack = function () {
    return this.cfg.packs[this.state.packIndex] || this.cfg.packs[0];
  };

  /* -------------------------------------------------------------- eventi */

  Personalizzatore.prototype.bind = function () {
    var self = this;
    var r = this.root;
    var redraw = debounce(this.render.bind(this), 60);

    // vista
    $$('[data-odsz-view]', r).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.view = btn.getAttribute('data-odsz-view');
        $$('[data-odsz-view]', r).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        self.render();
      });
    });

    // template
    $$('[data-odsz-template]', r).forEach(function (input) {
      input.addEventListener('change', function () {
        var tpl = null, id = input.value;
        self.cfg.templates.forEach(function (t) { if (t.id === id) tpl = t; });
        if (!tpl) return;
        self.state.template = tpl.id;
        self.state.bg = tpl.bg;
        self.state.ink = tpl.ink;
        self.state.frame = tpl.frame;
        self.state.font = tpl.font;
        // riallinea i controlli secondari
        $$('[data-odsz-ink]', r).forEach(function (i) { i.checked = i.value === tpl.ink; });
        $$('[data-odsz-font]', r).forEach(function (i) { i.checked = i.value === tpl.font; });
        var fr = $('[data-odsz-frame]', r);
        if (fr) fr.value = tpl.frame;
        self.render();
      });
    });

    // testi
    [['title', '[data-odsz-title]'], ['subtitle', '[data-odsz-subtitle]'], ['date', '[data-odsz-date]']]
      .forEach(function (pair) {
        var el = $(pair[1], r);
        if (!el) return;
        el.addEventListener('input', function () {
          self.state[pair[0]] = el.value;
          var counter = el.parentNode.querySelector('[data-odsz-count]');
          if (counter && el.maxLength > 0) counter.textContent = el.value.length + ' / ' + el.maxLength;
          redraw();
        });
      });

    // font, colore, cornice, slider
    $$('[data-odsz-font]', r).forEach(function (i) {
      i.addEventListener('change', function () { self.state.font = i.value; self.render(); });
    });
    $$('[data-odsz-ink]', r).forEach(function (i) {
      i.addEventListener('change', function () { self.state.ink = i.value; self.render(); });
    });
    var frameSel = $('[data-odsz-frame]', r);
    if (frameSel) frameSel.addEventListener('change', function () {
      self.state.frame = frameSel.value; self.render();
    });

    $$('[data-odsz-range]', r).forEach(function (input) {
      var key = input.getAttribute('data-odsz-range');
      input.addEventListener('input', function () {
        var v = parseFloat(input.value);
        if (key === 'logoScale') self.state.logo.scale = v;
        else if (key === 'logoY') self.state.logo.y = v;
        else self.state[key] = v;
        redraw();
      });
    });

    // upload immagine
    this.bindUpload();

    // pacchetti
    $$('[data-odsz-pack]', r).forEach(function (input) {
      input.addEventListener('change', function () {
        self.state.packIndex = parseInt(input.getAttribute('data-odsz-pack'), 10);
        self.syncPack();
      });
    });

    // drag del logo
    this.bindDrag();

    // invio
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  };

  Personalizzatore.prototype.bindUpload = function () {
    var self = this, r = this.root;
    var drop = $('[data-odsz-drop]', r);
    var input = $('[data-odsz-file]', r);
    if (!input) return;

    function handle(file) {
      if (!file) return;
      var maxMb = self.cfg.maxUploadMb || 18;
      if (file.size > maxMb * 1024 * 1024) {
        self.showErrors(['L\'immagine supera ' + maxMb + ' MB. Comprimila o inviala via email dopo l\'ordine.']);
        input.value = '';
        return;
      }
      readFileAsImage(file).then(function (res) {
        if (self.logoUrl) URL.revokeObjectURL(self.logoUrl);
        self.logoImg = res.img;
        self.logoUrl = res.url;
        self.state.logo = { x: 0.5, y: 0.17, scale: 0.34 };
        var thumb = $('[data-odsz-thumb]', r);
        if (thumb) {
          thumb.classList.add('odsz__thumb--on');
          $('img', thumb).src = res.url;
          $('[data-odsz-thumb-name]', thumb).textContent = file.name;
          // stima qualità: px reali vs px richiesti alla scala attuale
          var p = self.printPx();
          var neededW = p.w * self.state.logo.scale;
          var dpiEff = Math.round(res.img.naturalWidth / (neededW / self.cfg.dpi));
          var q = $('[data-odsz-thumb-dpi]', thumb);
          if (dpiEff >= 250) {
            q.textContent = 'Qualità ottima per la stampa (' + dpiEff + ' dpi)';
            q.className = 'odsz__thumb-dpi odsz__thumb-dpi--ok';
          } else if (dpiEff >= 150) {
            q.textContent = 'Qualità accettabile (' + dpiEff + ' dpi). Meglio un file più grande.';
            q.className = 'odsz__thumb-dpi odsz__thumb-dpi--warn';
          } else {
            q.textContent = 'Risoluzione bassa (' + dpiEff + ' dpi): rischio stampa sgranata.';
            q.className = 'odsz__thumb-dpi odsz__thumb-dpi--warn';
          }
        }
        $$('[data-odsz-logo-ctrl]', r).forEach(function (el) { el.hidden = false; });
        self.hideErrors();
        self.render();
      }).catch(function () {
        self.showErrors(['Non riesco a leggere questo file. Usa JPG, PNG o SVG.']);
      });
    }

    input.addEventListener('change', function () { handle(input.files[0]); });

    if (drop) {
      drop.addEventListener('click', function () { input.click(); });
      drop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); drop.classList.add('odsz__drop--over');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); drop.classList.remove('odsz__drop--over');
        });
      });
      drop.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!f) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(f);
          input.files = dt.files;
        } catch (err) { /* il file resta solo in anteprima */ }
        handle(f);
      });
    }

    var remove = $('[data-odsz-remove]', this.root);
    if (remove) remove.addEventListener('click', function () {
      input.value = '';
      if (self.logoUrl) URL.revokeObjectURL(self.logoUrl);
      self.logoImg = null; self.logoUrl = null;
      var thumb = $('[data-odsz-thumb]', r);
      if (thumb) thumb.classList.remove('odsz__thumb--on');
      $$('[data-odsz-logo-ctrl]', r).forEach(function (el) { el.hidden = true; });
      self.render();
    });
  };

  Personalizzatore.prototype.bindDrag = function () {
    var self = this, c = this.canvas, dragging = false, off = { x: 0, y: 0 };

    function pos(e) {
      var rect = c.getBoundingClientRect();
      return {
        x: (e.clientX - rect.left) / rect.width,
        y: (e.clientY - rect.top) / rect.height
      };
    }

    c.addEventListener('pointerdown', function (e) {
      if (!self.logoImg || self.view !== 'artwork') return;
      var p = pos(e);
      var r = self.logoRect(1, 1);
      if (p.x < r.x || p.x > r.x + r.w || p.y < r.y || p.y > r.y + r.h) return;
      dragging = true;
      off.x = p.x - self.state.logo.x;
      off.y = p.y - self.state.logo.y;
      c.setPointerCapture(e.pointerId);
      c.classList.add('odsz__canvas--dragging');
    });

    c.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var p = pos(e);
      self.state.logo.x = clamp(p.x - off.x, 0.05, 0.95);
      self.state.logo.y = clamp(p.y - off.y, 0.05, 0.95);
      var yRange = $('[data-odsz-range="logoY"]', self.root);
      if (yRange) yRange.value = self.state.logo.y;
      self.render();
    });

    ['pointerup', 'pointercancel'].forEach(function (ev) {
      c.addEventListener(ev, function () {
        dragging = false;
        c.classList.remove('odsz__canvas--dragging');
      });
    });
  };

  /* ------------------------------------------------------- pacchetti vino */

  Personalizzatore.prototype.syncPack = function () {
    var self = this;
    var pack = this.pack();
    var wrap = $('[data-odsz-bottles]', this.root);
    var idInput = $('[data-odsz-variant-id]', this.root);
    if (idInput) idInput.value = pack.variantId;

    if (wrap) {
      wrap.innerHTML = '';
      for (var i = 0; i < pack.bottles; i++) {
        var row = document.createElement('div');
        row.className = 'odsz__bottle';
        var n = document.createElement('span');
        n.className = 'odsz__bottle-n';
        n.textContent = String(i + 1);
        var sel = document.createElement('select');
        sel.className = 'odsz__select';
        sel.name = 'properties[Bottiglia ' + (i + 1) + ']';
        sel.setAttribute('aria-label', 'Vino della bottiglia ' + (i + 1));
        this.cfg.wines.forEach(function (w) {
          var o = document.createElement('option');
          o.value = w.name;
          o.textContent = w.name + (w.note ? ' — ' + w.note : '');
          sel.appendChild(o);
        });
        sel.value = this.state.wines[i] || this.cfg.wines[0].name;
        (function (idx, el) {
          el.addEventListener('change', function () {
            self.state.wines[idx] = el.value;
            self.updateSummaries();
          });
        })(i, sel);
        this.state.wines[i] = sel.value;
        row.appendChild(n); row.appendChild(sel);
        wrap.appendChild(row);
      }
      this.state.wines.length = pack.bottles;
    }

    var total = $('[data-odsz-total]', this.root);
    if (total) total.textContent = formatMoney(pack.price, this.cfg.moneyFormat);
    this.updateSummaries();
  };

  Personalizzatore.prototype.updateSummaries = function () {
    var s = this.state;
    var set = function (root, sel, txt) {
      var el = $(sel, root);
      if (el) el.textContent = txt;
    };
    set(this.root, '[data-odsz-sum="stile"]', this.template().name);
    set(this.root, '[data-odsz-sum="testo"]', s.title || '—');
    set(this.root, '[data-odsz-sum="immagine"]', this.logoImg ? 'Caricata' : 'Nessuna');
    set(this.root, '[data-odsz-sum="vini"]', this.pack().title);

    // valori tecnici salvati con l'ordine
    var hid = {
      'Stile': this.template().name,
      'Carattere': s.font,
      'Colore testo': s.ink,
      'Cornice': s.frame,
      'Testo principale': s.title,
      'Seconda riga': s.subtitle,
      'Data': s.date
    };
    Object.keys(hid).forEach(function (k) {
      var el = $('[data-odsz-prop="' + k + '"]', this.root);
      if (el) el.value = hid[k] || '';
    }, this);
  };

  /* -------------------------------------------------------------- submit */

  Personalizzatore.prototype.showErrors = function (list) {
    var box = $('[data-odsz-errors]', this.root);
    if (!box) return;
    box.innerHTML = '<ul><li>' + list.join('</li><li>') + '</li></ul>';
    box.classList.add('odsz__errors--on');
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  Personalizzatore.prototype.hideErrors = function () {
    var box = $('[data-odsz-errors]', this.root);
    if (box) box.classList.remove('odsz__errors--on');
  };

  Personalizzatore.prototype.validate = function () {
    var errs = [];
    var s = this.state;
    if (!s.title && !s.subtitle && !this.logoImg) {
      errs.push('Aggiungi almeno un testo oppure carica un\'immagine prima di continuare.');
    }
    var consent = $('[data-odsz-consent]', this.root);
    if (consent && !consent.checked) {
      errs.push('Conferma di aver controllato l\'anteprima: la produzione parte da quel file.');
    }
    if (errs.length) { this.showErrors(errs); return false; }
    this.hideErrors();
    return true;
  };

  Personalizzatore.prototype.onSubmit = function (e) {
    e.preventDefault();
    if (!this.validate()) return;

    var self = this;
    var btn = $('[data-odsz-submit]', this.root);
    btn.disabled = true;
    btn.classList.add('odsz__submit--busy');

    var mono = this.cfg.mode === 'cassa';
    var stamp = Date.now();

    Promise.all([this.exportArtwork(mono), this.exportPreview()])
      .then(function (blobs) {
        var okPrint = attachFile(
          $('[data-odsz-printfile]', self.root), blobs[0],
          (mono ? 'incisione' : 'stampa') + '-' + stamp + '.png'
        );
        attachFile($('[data-odsz-previewfile]', self.root), blobs[1], 'anteprima-' + stamp + '.jpg');

        if (!okPrint) {
          // Browser senza DataTransfer: l'ordine conserva comunque i dati testuali
          // e l'immagine originale caricata dal cliente.
          var flag = $('[data-odsz-prop="Nota tecnica"]', self.root);
          if (flag) flag.value = 'File automatico non generato — ricomporre da parametri';
        }

        if (self.cfg.demo) {
          btn.disabled = false;
          btn.classList.remove('odsz__submit--busy');
          self.root.dispatchEvent(new CustomEvent('odsz:demo-submit', {
            bubbles: true,
            detail: { print: blobs[0], preview: blobs[1], attached: okPrint, state: self.state }
          }));
          return;
        }

        self.form.submit(); // submit nativo: non ripassa da questo handler
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('odsz__submit--busy');
        self.showErrors(['Non sono riuscito a generare il file di stampa. Riprova o contattaci.']);
      });
  };

  /* ------------------------------------------------------------------ go */

  function init() {
    $$('[data-odsz-root]').forEach(function (el) {
      if (el.__odsz) return;
      try { el.__odsz = new Personalizzatore(el); }
      catch (err) { if (window.console) console.error('[odsz]', err); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.OdszPersonalizzatore = Personalizzatore;
})();
